<template>
  <ts-loading-banner :loading="loading">
    <Table 
      :data="resources" 
			:columns="columns" 
			size="small"
			highlight-row
      stripe
			max-height="700"
    >
        <template slot-scope="{ row }" slot="roleName">
          <span
            class="badge badge-primary mr-2"
            v-for="(role, index) in row.roles"
            :key="index"
            >{{ role.name == '*' ? 'Everything' : role.name }}</span
          >
        </template>
        <template slot-scope="{ row }" slot="disable">
          <span class="badge badge-success" v-if="!row.disable">Yes</span>
          <span class="badge badge-danger" v-else>No</span>
        </template>
    </Table>
    <div class="d-flex justify-content-between align-items-center p-15">
      <ts-total-list v-model="pagination" />
      <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
    </div>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import expandRow from './table-expand.vue'
export default {
  name: 'userIndex',
  data() {
    return {
      loading: false,
      errors: new Errors(),
      waiting: false,
    }
  },
  computed: {
    ...mapState('security/userPermissionReport', ['pagination']),
    resources () {
        let resources = []
        this.$store.state.security.userPermissionReport.resources.forEach(
            resource => {
                resources.push(Object.assign(resource, { _expanded: true }))
            }
        )
        return resources
    },
    search: {
      get() {
        return this.$store.state.security.userPermissionReport.search
      },
      set(newValue) {
        this.$store.commit('security/userPermissionReport/SET_SEARCH', newValue)
        this.$store.commit('security/userPermissionReport/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        {
          type: 'expand',
          render: (h, params) => {
              return h(expandRow, {
                  props: {
                      permission_reports: params.row.permission_reports
                  }
              })
          },
          width: 20
        },
        { 
          title: this.$t('user.branchName'),
          key: 'branch_name_en' 
        },
        { 
          title: this.$t('user.name'),
          key: 'name' 
        },
        { 
          title: this.$t('user.userName'),
          key: 'user_name' 
        },
        { 
          title: this.$t('user.roleName'),
          slot: 'roleName' 
        },
        { 
          title: this.$t('user.active'),
          slot: 'disable' 
        },
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('security/userPermissionReport/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('security/userPermissionReport/RESET_STATE')
    next()
  }
}
</script>
